import { apiResponseError, unknownError } from './factories';
import { handleLegacyError } from './legacy';
import { ErrorEnvelopeSchema } from './schemas';
import type { ApiError } from '../types';

/**
 * Turns a raw HTTP error response into a type-safe ApiError, in three steps:
 * 1. A body in the Manage API error envelope, on any status, becomes an `ApiResponseError`
 *    carrying the unwrapped `error` object.
 * 2. A body in one of the older per-status shapes (`legacy.ts`) becomes an `ApiResponseError`.
 * 3. Anything else becomes an `UnknownError`, so no response goes unhandled.
 */
export const apiErrorHandler = (status: number, error: unknown): ApiError => {
  const envelope = ErrorEnvelopeSchema.safeParse(error);

  if (envelope.success) {
    return apiResponseError(envelope.data.message, status, envelope.data);
  }

  return handleLegacyError(status, error) ?? unknownError('Unknown error', status, error);
};
